
import { defineComponent } from 'vue';
import { imageService } from '@/shared/services/ImageService';

export default defineComponent({
  name: 'ResizableImage',
  props: {
    url: String,
    height: Number,
    width: Number,
    rmode: String,
    hrmode: String,
    wrmode: String,
    bgcolor: String,
    placeholder: String,
    backgroundImage: Boolean,
    classes: String,
  },
  computed: {
    showImage: function () {
      return this.url || this.placeholder;
    },
    src: function () {
      return imageService.getImage(this.url, this.placeholder, {
        height: this.height,
        width: this.width,
        rmode: this.rmode,
        hrmode: this.hrmode,
        wrmode: this.wrmode,
        bgcolor: this.bgcolor,
      });
    },
  },
});
